import Paper from "@material-ui/core/Paper";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import cx from "classnames";

const styles: StyleRulesCallback = theme => ({
  paper: {
    boxShadow:
      "0px 0px 0px 0px rgba(0,0,0,0.10), 0px 2px 2px 0px rgba(0,0,0,0.10), 0px 3px 1px -2px rgba(0,0,0,0.10)"
  },
  sticky: {
    left: 0,
    margin: "0 auto",
    maxWidth: "inherit",
    position: "fixed",
    right: 0,
    top: 0,
    transform: "translateZ(0px)",
    zIndex: theme.zIndex.appBar
  }
});

interface IContainerProps extends WithStyles<typeof styles> {
  isSticky: boolean;
  ref?: React.Ref<HTMLElement>;
}

const BasePaper: React.FC<IContainerProps> = ({ classes, isSticky, ref, children }) => (
  <Paper
    innerRef={ref}
    square={true}
    elevation={0}
    className={cx(classes.paper, { [classes.sticky]: isSticky })}
  >
    {children}
  </Paper>
);

export const StyledPaper = withStyles(styles)(BasePaper);
